import { Box, Link } from "@chakra-ui/react";
import NextLink from "next/link";
import {
    Field,
    ImageField,
    LinkField,
    useSitecoreContext,
} from "@sitecore-jss/sitecore-jss-nextjs";
import ImageCard from "components/ui/ImageCard";
import { gtmCTAEvent } from "components/head/GTMTracking";

interface Fields {
    Image: ImageField;
    Headline: Field<string>;
    Text?: Field<string>;
    CTA?: LinkField;
}

export type ImageCarouselElementProps = {
    params: { [key: string]: string };
    fields: Fields;
};

const ImageCarouselElement = (props: ImageCarouselElementProps) => {
    const {
        sitecoreContext: { pageEditing },
    } = useSitecoreContext();

    return (
        <Box height="100%" flex={pageEditing ? 1 : undefined}>
            {props.fields?.CTA?.value.href && !pageEditing ? (
                <Link
                    as={NextLink}
                    href={`${props.fields?.CTA?.value.href}`}
                    title={props.fields?.CTA?.value.title}
                    position="relative"
                    height="100%"
                    display="flex"
                    flexDir="column"
                    data-group
                    pb={
                        props.fields?.CTA?.value.href && props.fields?.Text?.value.trim()
                            ? "sp28"
                            : 0
                    }
                    mb={
                        props.fields?.CTA?.value.href && props.fields?.Text?.value.trim()
                            ? ["sp4", null, null, null, 0]
                            : 0
                    }
                    pointerEvents={pageEditing ? "none" : "all"}
                    onClick={() => {
                        gtmCTAEvent(
                            props.fields?.Headline.value,
                            "Image carousel link",
                            props.fields?.CTA?.value.href
                        );
                    }}
                >
                    <ImageCard fields={props.fields} />
                </Link>
            ) : (
                <Box
                    lineHeight="none"
                    fontWeight="medium"
                    letterSpacing="wide"
                    position="relative"
                    height="100%"
                    display="flex"
                    flexDir="column"
                    data-group
                    pb={
                        props.fields?.CTA?.value.href && props.fields?.Text?.value.trim()
                            ? "sp28"
                            : 0
                    }
                >
                    <ImageCard fields={props.fields} />
                </Box>
            )}
        </Box>
    );
};

export default ImageCarouselElement;
